export default "/images/card-list.svg?3f2ae3c2217574add671636f07df8639";